module.exports = __webpack_public_path__ + "img/SL7_4579_2-Bearbeitet.38d7cb9f.jpg";